/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

const SkeletonIcon = _ref => {
  let {
    className,
    ...other
  } = _ref;
  const prefix = usePrefix();
  const skeletonIconClasses = cx(className, {
    [`${prefix}--icon--skeleton`]: true
  });
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: skeletonIconClasses
  }, other));
};
SkeletonIcon.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string,
  /**
   * The CSS styles.
   */
  style: PropTypes.object
};

export { SkeletonIcon as default };
